import { OrganizationLinkBase, OrganizationLinkPressable } from './components';
import { OrganizationLinkContactUs, OrganizationLinkPrivacyChoices } from './variations';

// ─────────────────────────────────────────────────────────────────────────────

export const OrganizationLink = {
  Base: OrganizationLinkBase,
  Pressable: OrganizationLinkPressable,
  PrivacyChoices: OrganizationLinkPrivacyChoices,
  ContactUs: OrganizationLinkContactUs,
};
